export enum EPrePartnerType {
  PHYSICAL = 'PHYSICAL',
  LEGAL = 'LEGAL',
}
export interface IPrePartner {
  type: EPrePartnerType;
  document: string;
  name: string;
  companyName?: string;
  cnpj: string;
  participation: string;
  responsible: boolean;
  legalRepresentative?: boolean;
  fromRepresentativeForm?: boolean;

  // Optional fields filled in PartnerFinish form (camelCase)
  socialName?: string;
  birthDate?: string;
  motherName?: string;
  phoneNumber?: string;
  email?: string;
  pep?: string;
  addressPostalCode?: string;
  addressStreet?: string;
  addressNumber?: string;
  addressComplement?: string;
  addressNeighborhood?: string;
  addressCity?: string;
  addressState?: string;
  revenue?: string;
  isError?: boolean;
}

/** Identity key: CNPJ for PJ, CPF for PF. */
export function getPartnerKey(partner: Pick<IPrePartner, 'type' | 'document' | 'cnpj'>): string {
  return partner.type === EPrePartnerType.LEGAL ? partner.cnpj : partner.document;
}

export enum EParticipantType {
  OWNER = 'OWNER',
  ASSOCIATE = 'ASSOCIATE',
}
export interface CreateBankingAccountParticipant {
  type: EParticipantType;
  fullName: string;
  socialName: string;
  birthDate: string;
  documentNumber: string;
  motherName: string;
  phoneNumber: string;
  email: string;
  pep: boolean;
  addressPostalCode: string;
  addressStreet: string;
  addressNumber: string;
  addressComplement: string;
  addressNeighborhood: string;
  addressCity: string;
  addressState: string;
  revenue: string;
}

export interface CreateBankingAccount {
  cnpj: string;
  tradingName: string;
  businessName: string;
  phoneNumber: string;
  email: string;
  addressPostalCode: string;
  addressStreet: string;
  addressNumber: string;
  addressComplement: string;
  addressNeighborhood: string;
  addressCity: string;
  addressState: string;
  revenue: string;
  participants: CreateBankingAccountParticipant[];
}
